import React from 'react'
import { UI } from 'components'
import Selector from './Selector'

const Home = () => {
  return (
    <div className="flex flex-col mt-6 space-y-6">
      <UI.Header
        title="Elige tu simulador"
        subtitle="¿Cuánto crédito puedo pedir?, ¿para cuánto me alcanza? ¿cuánto debo pagar de impuesto? Conoce las respuestas rápido y fácil con nuestros simuladores."
        classNames={{ subtitle: 'text-secondary max-w-[480px] mx-auto' }}
      />
      <Selector />
    </div>
  )
}

export default Home
